<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

			<div class="row">
        
        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Solicitud Compras
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en compras</p>
            </div>
          </div>
        </div>

      
      </div>

				
			<div class="d-inline">
				<button type="button" v-on:click="generateCVS" class="btn btn-primary">
					CSV
				</button>
			</div>
	
			<div class="float-right">
				<button type="button" v-b-modal.modalFilters class="btn btn-primary">
					Filtros
				</button>
			</div>

			
			

			
			<div class="">
				
			</div>
			<div class="table table-padded">
				<b-card>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
                
               :items="adminBuys"
               :fields="fields"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
                @filtered="onFiltered" class="table table-padded"
          >

               <template slot="status" slot-scope="row">
                 <template v-if="row.item.status == 2">
                    Aprobada
                  </template>
                  <template v-else-if="row.item.status == 1">
                    Pendiente
                  </template>
                  <template v-else>
                    Rechazada
                  </template>
               </template>

               <template slot="createdAt" slot-scope="row">
                 {{row.item.createdAt.substr(0, 10)}}
               </template>

               <template slot="createdAtHour" slot-scope="row">
                 {{row.item.createdAt.substr(11, 5)}}
               </template>

                <template slot="company" slot-scope="row">
                 {{row.item.Company.name}}
               </template>

               <template slot="buyAt" slot-scope="row">
                 {{row.item.buyAt.substr(0, 10)}}
               </template>

               <template slot="buyAtHour" slot-scope="row">
                 {{row.item.buyAt.substr(11, 5)}}
               </template>

               
               <template slot="carrier" slot-scope="row">
                   <img :src="'/providers/'+row.item.Carrier.image" class="bank">
                </template>

                <template slot="description" slot-scope="row">
                   {{row.item.description}}
                </template>


               <template slot="amount" slot-scope="row">
                <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>
               </template>

   
 

                <template slot="action" slot-scope="row" >
	                <template v-if="row.item.status == 1">
									
										<button v-b-modal.modalRejectPurchase class="actionBtnTable nobtn" v-on:click='currentBuy(row.item)' ><i class="material-icons" style="color: #dab51b;">clear</i></button>
			              <button v-b-modal.modalApprovePurchase class="actionBtnTable" v-on:click='currentBuy(row.item)' ><i class="material-icons">done</i></button>

					        </template>

				        	<button v-if="row.item.observation" v-b-modal.modalShowBuy v-on:click="currentBuy(row.item)"  type="button" class="actionBtnTable nobtn">
		    					<i class="material-icons" style="color: #dab51b;">remove_red_eye</i></button>
                </template> 
               

				</b-table>

        <b-row>
          <b-col md="12" class="my-1 float-right">
            <b-pagination :total-rows="adminBuys.length" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>


      </b-card >






					<!--thead>
						<tr>
							<th>{{$t('table.status')}}</th>
							<th>{{$t('table.date')}}</th>
							<th>{{$t('table.hour')}}</th>
							<th>{{$t('table.company')}}</th>
							<th>{{$t('table.dateShop')}}</th>
							<th>{{$t('table.carrier')}}</th>
							<th>{{$t('table.observation')}}</th>
							<th>{{$t('table.value')}}</th>
							<th>{{$t('table.action')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(adminBuy, index) in adminBuys" :key="index">
							
							<td>
								<template v-if="adminBuy.status == 1">
				                  Pendiente
				                </template>
				                <template v-else-if="adminBuy.status == 2">
				                  Aprobada
				                </template>
				                <template v-else-if="adminBuy.status == 3">
				                  Rechazada
				                </template>
							</td>
							<td>{{adminBuy.createdAt.substr(0, 10)}}</td>
							<td>{{adminBuy.createdAt.substr(11, 5)}}</td>
							<td>{{adminBuy.Company.name}}</td>
							<td>{{adminBuy.buyAt.substr(0, 10)}}</td>

							<td>
				              <img :src="'/providers/'+adminBuy.Carrier.image" class="bank">
				            </td>
							<td>{{adminBuy.description}}</td>
							
							<td>
								<h2 class="itemIndicator" >${{money(adminBuy.amount)}}</h2>
							</td>
							<td>
								<template v-if="adminBuy.status == 1">
								
									<button v-b-modal.modalRejectPurchase class="actionBtnTable nobtn" v-on:click='currentBuy(adminBuy)' ><i class="material-icons" style="color: #dab51b;">clear</i></button>
		              <button v-b-modal.modalApprovePurchase class="actionBtnTable" v-on:click='currentBuy(adminBuy)' ><i class="material-icons">done</i></button>

				        </template>

				        	<button v-if="adminBuy.observation" v-b-modal.modalShowBuy v-on:click="currentBuy(adminBuy)"  type="button" class="actionBtnTable nobtn">
		    					<i class="material-icons" style="color: #dab51b;">remove_red_eye</i></button>

			        </td>

						</tr>
					</tbody-->
				

			
			</div>



			
		</div>
			
		<app-footer/>

	<b-modal id="modalRejectPurchase" ref="modalRejectPurchase" title="Rechazar" size="sm" centered @ok="process('reject')" 	>
		<div class="">
        
	        <p>Esta seguro que desea rechazar ésta compra?</p>

	        <div class="form-group">
				<label class='col-lg-12 control-label'>Observación </label>
				<textarea type="textarea" class="form-control" v-model='processForm.observation'></textarea>		
			</div>
	        
      </div>
	</b-modal>

	<b-modal id="modalApprovePurchase" title="Aprobar" size="sm" centered @ok="process('approve')">
		<div class=""   >
        <p>Esta seguro que desea aprobar ésta compra?</p>
      	<div class="form-group">
				<label class='col-lg-12 control-label'>Observación </label>
				<textarea type="textarea" class="form-control" v-model='processForm.observation'></textarea>		
			</div>
      </div>   
	</b-modal>

	<b-modal id="modalFilters" ref="modalFilters" centered   class='box-modal' title = "Filtrar Compras" hide-footer>
      	
      	<div class="box-modal">
      	<form v-on:submit.prevent="read"> 

	      	<div class="form-group">
			
				<label class='control-label'>Fecha de la compra</label>		
				<input type="date"  class="form-control" v-model='filters.dateStart'>		
			</div>

			<div class="form-group">
			
				<label class='control-label'>Fecha de la compra</label>		
				<input type="date"  class="form-control" v-model='filters.dateEnd'>		
			</div>

			
			<div class="form-group">
				<label class='control-label'>Código Empresa</label>
				<input type="text"  class="form-control" v-model='filters.codeCompany'>	
			</div>

			<div class="form-group">
				
				<label class='control-label'>Operador</label>
			    <select class="form-control" v-model="filters.carrierId">
			    	<option v-for="(carrier, index) in carriers" :key="index" :value="carrier.id">
			    		{{carrier.name}}
			    	</option>
			    </select>	
			</div>

			<div class="form-group">
          <label class='control-label'>Estado</label>
          <select class="form-control" v-model="filters.status">
            <option value="1" >Pendiente</option>
            <option value="2" >Aprobada</option>
            <option value="0" >Rechazada</option>
          </select> 
      </div>

			<div class="d-inline mr-4">
		        <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
		        </button>
		    </div>
	      	<div class="d-inline">
	        	<button type="submit" class="btn btn-primary">Filtrar</button>
	      	</div>
      	</form>

      	</div>    
        
    </b-modal>

	

    <b-modal id="modalShowBuy" hide-footer ref="modalShowBuy" centered class='box-modal' title = "Compra">
		{{current.observation}}
    </b-modal>

    





	</div>
</template>


<script>
import { mapGetters } from "vuex";
import { FETCH_ADMINBUYS, FETCH_CARRIERS } from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";
import { PROCESS_BUYS } from "@/store/actions.type";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      processForm: {
        onservation: ""
      },
      data: {},
      current: {},
      filters: {
        dateStart: "",
        dateEnd: "",
        codeCompany: "",
        carrierId: ""
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "status", label: "Estado", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "company", label: "Compañia", sorteable: true },
        { key: "buyAt", label: "Fecha Compra", sorteable: true },
        { key: "buyAtHour", label: "Hora Compra", sorteable: true },
        { key: "carrier", label: "Operador", sorteable: true },
        { key: "description", label: "Descripción", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_CARRIERS);
    this.read();
  },
  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_ADMINBUYS, this.filters);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    process(type) {
      var data = {
        buyId: this.current.id,
        type: type,
        observation: this.processForm.observation
      };
      this.$store
        .dispatch(PROCESS_BUYS, data)
        .then(result => {
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    currentBuy(current) {
      this.current = current;
    },

    showBuy(buy) {
      this.current = buy;
      this.$refs.showBuy.show();
    },

    generateCVS() {
      var total = 0;
      var rows = this.adminBuys.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;

        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          item.Company.name,
          item.buyAt.substr(0, 10),
          item.Carrier.name,
          item.description,
          "$" + item.amount
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Empresa",
          "Fecha de Compra",
          "Operador",
          "Observacion",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Compras.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["adminBuys", "carriers"]),

    total: function() {
      var total = 0;
      this.adminBuys.map(row => (total += row.amount));
      return total;
    }
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
